var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuildingMobile = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 755.01 374.33",
  ref: ref,
  "aria-labelledby": titleId
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.03,
  width: 754.98,
  height: 374.33,
  style: {
    fill: "none"
  }
})), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 384.95,
  y1: 207.58,
  x2: 485.21,
  y2: 207.58,
  gradientTransform: "matrix(1, 0.03, -0.03, 1, 5.41, -9.94)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00d38d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
}))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 413.58,
  y1: 216.17,
  x2: 423.32,
  y2: 206.43,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#linear-gradient"
})), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 458.31,
  y1: 233.94,
  x2: 468.05,
  y2: 224.2,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#linear-gradient"
})), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 226.89,
  y1: 207.48,
  x2: 135.77,
  y2: 207.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f4b01a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
}))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 170.73,
  y1: 213.27,
  x2: 178.66,
  y2: 205.35,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 206.16,
  y1: 213.27,
  x2: 214.08,
  y2: 205.35,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 189.36,
  y1: 198.47,
  x2: 197.28,
  y2: 190.55,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 287.79,
  y1: 75.72,
  x2: 308.39,
  y2: 75.72,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ac41d8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
}))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 1516.55,
  y1: 911.49,
  x2: 1533.77,
  y2: 911.49,
  gradientTransform: "translate(-982.68 1275.51) rotate(-73.55)",
  xlinkHref: "#linear-gradient-8"
})), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 286.01,
  y1: 76.22,
  x2: 319.84,
  y2: 76.22,
  gradientTransform: "matrix(-1, 0, 0, 1, 615.63, 0)",
  xlinkHref: "#linear-gradient-8"
})), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 319.68,
  y1: -856.23,
  x2: 347.61,
  y2: -856.23,
  gradientTransform: "matrix(-0.87, -0.49, -0.49, 0.87, 158.42, 1043.92)",
  xlinkHref: "#linear-gradient"
})), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 518.68,
  y1: -744.8,
  x2: 546.6,
  y2: -744.8,
  gradientTransform: "translate(242.46 1043.92) rotate(-29.25)",
  xlinkHref: "#linear-gradient"
})), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 282.13,
  y1: 153.87,
  x2: 346.9,
  y2: 153.87,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#linear-gradient"
})), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: 124.8,
  y1: 146.55,
  x2: 178.91,
  y2: 146.55,
  gradientTransform: "matrix(-0.99, -0.11, -0.11, 0.99, 569.01, 37.24)",
  xlinkHref: "#linear-gradient-4"
})), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-15",
  x1: 3410.57,
  y1: 118.61,
  x2: 3439.6,
  y2: 118.61,
  gradientTransform: "translate(-3013.94 155.06) rotate(-2.05)",
  xlinkHref: "#linear-gradient-4"
})), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-16",
  x1: 1321.34,
  y1: 1008.24,
  x2: 1339.57,
  y2: 1008.24,
  gradientTransform: "translate(-862.22 1382.35) rotate(-79.08)",
  xlinkHref: "#linear-gradient-8"
})), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-17",
  x1: 225.14,
  y1: 274.52,
  x2: 265.29,
  y2: 274.52,
  gradientTransform: "matrix(-1, 0, 0, 1, 615.63, 0)",
  xlinkHref: "#linear-gradient-8"
})), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-18",
  x1: 342.15,
  y1: 272.11,
  x2: 363.46,
  y2: 272.11,
  xlinkHref: "#linear-gradient-8"
})), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-19",
  x1: 545.79,
  y1: 224.28,
  x2: 719.35,
  y2: 224.28,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-20",
  x1: 641,
  y1: 215.23,
  x2: 687.06,
  y2: 215.23,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#linear-gradient"
})), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-21",
  x1: 642.58,
  y1: 243.67,
  x2: 685.42,
  y2: 243.67,
  xlinkHref: "#linear-gradient-4"
})), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-22",
  x1: 27.85,
  y1: -948.91,
  x2: 42.65,
  y2: -948.91,
  gradientTransform: "matrix(-1, -0.07, -0.07, 1, 548.73, 1153.91)",
  xlinkHref: "#linear-gradient-8"
})), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-23",
  x1: 725.96,
  y1: -551.7,
  x2: 740.76,
  y2: -551.7,
  gradientTransform: "translate(242.46 1043.92) rotate(-29.25)",
  xlinkHref: "#linear-gradient-8"
})), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-24",
  x1: 580.36,
  y1: 214.88,
  x2: 614.69,
  y2: 214.88,
  xlinkHref: "#linear-gradient-8"
})), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-25",
  x1: 82.96,
  y1: 180.22,
  x2: 102.73,
  y2: 180.22,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#linear-gradient"
}))), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "LOGIN_MRV_VETOR_mobile") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#clip-path)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M389.47,200.93v-82.2a7.47,7.47,0,0,1,8.43-7.41L434.47,116a7.47,7.47,0,0,1,6.52,7.41v73.14",
  style: {
    fill: "#d7d8d6",
    opacity: 0.09
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.8,256,68.68,108.63A4.63,4.63,0,0,0,64.05,104H27.61a11.94,11.94,0,0,0-7.27,2.46c-5.56,4.24-16.88,14.06-22.67,19.13a10.52,10.52,0,0,0-3.59,7.9l2.21,129.19",
  style: {
    fill: "#d7d8d6",
    opacity: 0.2
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    opacity: 0.6000000000000001
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M728.4,252.16V172.28a8.52,8.52,0,0,0-9.61-8.45l-41.73,5.37a8.52,8.52,0,0,0-7.43,8.45v94.54",
  style: {
    fill: "#d7d8d6",
    opacity: 0.6000000000000001
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M118.63,244.89l2.2-107.41a4.81,4.81,0,0,1,4.82-4.81h37.9a12.46,12.46,0,0,1,7.56,2.55c5.78,4.41,17.56,14.63,23.58,19.9a10.93,10.93,0,0,1,3.73,8.22l-2.3,88.48",
  style: {
    fill: "#d7d8d6",
    opacity: 0.18
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M371.1,250V156.75a10,10,0,0,0-11.21-9.86l-48.69,6.28a9.93,9.93,0,0,0-8.67,9.86V273.32",
  style: {
    fill: "#d7d8d6",
    opacity: 0.18
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M453.19,247.62v-93.2a10,10,0,0,1,11.22-9.86l48.68,6.27a10,10,0,0,1,8.68,9.86V271",
  style: {
    fill: "#d7d8d6",
    opacity: 0.2
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M577.7,252.7V200.21c0-7.29-4-12.91-8.43-12l-36.59,7.62c-3.73.77-6.52,5.91-6.52,12v73.26",
  style: {
    fill: "#d7d8d6",
    opacity: 0.6000000000000001
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.22,266.49V189.2c0-4.23-4.63-7.5-9.85-7L2.62,186.67c-4.36.45-7.62,3.43-7.62,7V262.4",
  style: {
    fill: "#d7d8d6",
    opacity: 0.6000000000000001
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M281.15,274.49V197.2c0-4.23-4.62-7.5-9.84-7l-42.76,4.43c-4.35.45-7.61,3.43-7.61,7V270.4",
  style: {
    fill: "#d7d8d6",
    opacity: 0.6000000000000001
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M80,260,79.38,86.5c0-3.63,4-6.43,8.47-6l36.77,3.79c3.74.39,6.55,2.94,6.55,6L134,260",
  style: {
    fill: "#d7d8d6",
    opacity: 0.2
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M614,273.12l-2.12-147.39a4.63,4.63,0,0,0-4.63-4.63H570.82a12,12,0,0,0-7.27,2.45c-5.56,4.25-16.88,14.07-22.68,19.14a10.51,10.51,0,0,0-3.58,7.9l2.21,129.18",
  style: {
    fill: "#d7d8d6",
    opacity: 0.2
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.88,213.18V107c0-3.63,4-6.43,8.47-6l36.77,3.79c3.74.39,6.55,2.94,6.55,6v98.89",
  style: {
    fill: "#d7d8d6",
    opacity: 0.2
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M484.12,248.94l1.76-68.26c.23-9.31-6-16.59-13.21-15.34L395.6,178.78c-5.76,1-10.15,7.26-10.34,14.74L383.75,252",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M484.12,248.94l1.76-68.26c.23-9.31-6-16.59-13.21-15.34L395.6,178.78c-5.76,1-10.15,7.26-10.34,14.74L383.75,252",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 413.02,
  y: 188.11,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 413.02,
  y: 205.88,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#edf1f0"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 413.02,
  y: 205.88,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-2)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 413.02,
  y: 223.65,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 435.39,
  y: 188.11,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 435.39,
  y: 205.88,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 435.39,
  y: 223.65,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 457.76,
  y: 188.11,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 457.76,
  y: 205.88,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 457.76,
  y: 223.65,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#edf1f0"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 457.76,
  y: 223.65,
  width: 10.85,
  height: 10.85,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-3)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M511,207.53l-6.81,18.17a5.26,5.26,0,0,0,4.92,7.1h14.43a5.26,5.26,0,0,0,4.92-7.1l-6.83-18.17a5.25,5.25,0,0,0-4.91-3.4H516A5.25,5.25,0,0,0,511,207.53Z",
  style: {
    fill: "#079d56"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M511,207.53l-6.81,18.17a5.26,5.26,0,0,0,4.92,7.1h14.43a5.26,5.26,0,0,0,4.92-7.1l-6.83-18.17a5.25,5.25,0,0,0-4.91-3.4H516A5.25,5.25,0,0,0,511,207.53Z",
  style: {
    fill: "#006b3f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M514.67,219.44v29.47a1.25,1.25,0,0,0,2.5,0V219.44a1.25,1.25,0,0,0-2.5,0Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M515.92,227.94c3.29-.08,6.86-1.7,7.74-5.11a1.25,1.25,0,0,0-2.41-.66c-.59,2.29-3.18,3.21-5.33,3.27a1.25,1.25,0,0,0,0,2.5Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.77,246.11v-67.8c0-9.25,5.86-16.32,12.35-14.89l69.72,15.31c5.21,1.14,9,7.46,9,14.89v58.11",
  style: {
    fill: "#f4b01a"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.77,246.11v-67.8c0-9.25,5.86-16.32,12.35-14.89l69.72,15.31c5.21,1.14,9,7.46,9,14.89v58.11",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-4)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 151.55,
  y: 189.99,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 151.55,
  y: 204.79,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.55,229.08h-7.29a.87.87,0,0,1-.87-.87v-7.29a.88.88,0,0,1,.87-.88h7.29c.48,0,2-.06,2,.43l-1.16,7.74A.87.87,0,0,1,158.55,229.08Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 170.17,
  y: 189.99,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 170.17,
  y: 204.79,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#edf1f0"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 170.17,
  y: 204.79,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-5)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 170.17,
  y: 219.59,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 205.6,
  y: 189.99,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 205.6,
  y: 204.79,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#edf1f0"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 205.6,
  y: 204.79,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-6)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 205.6,
  y: 219.59,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 188.8,
  y: 189.99,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#edf1f0"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 188.8,
  y: 189.99,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "url(#linear-gradient-7)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 188.8,
  y: 204.79,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 188.8,
  y: 219.59,
  width: 9.04,
  height: 9.04,
  rx: 1.9,
  ry: 1.9,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.17,248.56c.9-1.72,5-4.25,7.37-5.07.74-.26,2.64-.29,3.19-.63.82-.51,1.43-1.92,2.22-2.63,3.82-3.45,8.58-2.65,11.89,1.32,4.86-3.67,11.57-3.29,15.26,2.09,5.27-4.24,12.75.39,14.31,5.85",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: -5.94,
  y: 247.17,
  width: 853.71,
  height: 134.77,
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.72,170.13,33.43,204a9.8,9.8,0,0,1-9.17,13.24H-2.68A9.8,9.8,0,0,1-11.85,204L.88,170.12a9.8,9.8,0,0,1,9.18-6.35h1.48A9.8,9.8,0,0,1,20.72,170.13Z",
  style: {
    fill: "#079d56"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.72,170.13,33.43,204a9.8,9.8,0,0,1-9.17,13.24H-2.68A9.8,9.8,0,0,1-11.85,204L.88,170.12a9.8,9.8,0,0,1,9.18-6.35h1.48A9.8,9.8,0,0,1,20.72,170.13Z",
  style: {
    fill: "#079d56"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.34,192.34v55a1.25,1.25,0,0,0,2.5,0v-55a1.25,1.25,0,0,0-2.5,0Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.59,208.89c3.9-.09,8.16-2,9.21-6a1.25,1.25,0,0,0-2.41-.66c-.76,2.93-4,4.14-6.8,4.21a1.25,1.25,0,0,0,0,2.5Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.15,188.37c-1,8.42-2.59,21.81-3.58,29.93a7.11,7.11,0,0,0,6.25,7.91l22.95,3a7.84,7.84,0,0,0,8.72-6.32l5.12-30a7.11,7.11,0,0,0-6.27-8.26l-24.49-3A7.8,7.8,0,0,0,708.15,188.37Z",
  style: {
    fill: "#006b3f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.15,188.37c-1,8.42-2.59,21.81-3.58,29.93a7.11,7.11,0,0,0,6.25,7.91l22.95,3a7.84,7.84,0,0,0,8.72-6.32l5.12-30a7.11,7.11,0,0,0-6.27-8.26l-24.49-3A7.8,7.8,0,0,0,708.15,188.37Z",
  style: {
    fill: "#079d56"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M723.81,203.56v44.77a1.25,1.25,0,0,0,2.5,0V203.56a1.25,1.25,0,0,0-2.5,0Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M714.52,214.54l9.91,6.94c1.32.92,2.57-1.24,1.26-2.16l-9.91-6.94c-1.32-.92-2.57,1.25-1.26,2.16Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.33,205.45l-9.9,6.93c-1.31.92-.06,3.09,1.26,2.16l9.91-6.93c1.3-.92.06-3.09-1.27-2.16Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M500.42,188.49l10.4,31.28c2,5.91-1.91,12.21-7.5,12.21h-22c-5.6,0-9.47-6.31-7.5-12.22l10.41-31.27a8.12,8.12,0,0,1,7.5-5.86h1.22A8.11,8.11,0,0,1,500.42,188.49Z",
  style: {
    fill: "#079d56"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M491.71,202.55v45a1.25,1.25,0,0,0,2.5,0v-45a1.25,1.25,0,0,0-2.5,0Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M493,224.8c3-.07,6.22-1.55,7-4.64a1.25,1.25,0,0,0-2.41-.67c-.52,2-2.86,2.77-4.61,2.81a1.25,1.25,0,0,0,0,2.5Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M493,210.27c3-.07,6.22-1.55,7-4.64a1.25,1.25,0,0,0-2.41-.67c-.52,2-2.86,2.77-4.61,2.81a1.25,1.25,0,0,0,0,2.5Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M492.3,216.4c-1.75,0-4.09-.8-4.61-2.81a1.25,1.25,0,0,0-2.41.66c.8,3.1,4,4.58,7,4.65a1.25,1.25,0,0,0,0-2.5Z",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M-28.6,252.83c2.85-1.46,4.55-5,8-5.5,2.59-.38,4.15,1.18,6.37-.05,2.72-1.52,3.56-4.31,7.08-4.79A8.35,8.35,0,0,1-1,243.79c3.82-2.7,5.93-6.25,11.29-6.87,5-.57,10.33,2.22,13.3,6.16,1.55,2.07.91,2.11,3.48,2.34,2.07.19,3.41-.27,5.46,1a15.35,15.35,0,0,1,5.63,7",
  style: {
    fill: "#006b3f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M-26.31,308.4c17-9.95,33-16.21,53.9-19.6a207.31,207.31,0,0,1,63.2-.34c20.27,3,38.39,8.47,56.8,15.82,10.64,4.26,56.55,17.81,68.93,19,27.13,2.52,57.1-3.79,81.79-12.39,12.57-4.38,76.61-28.56,137.79-25.29,56.42,3,108,20.54,162.48,31.1,30.34,5.88,105.22.67,125.43-4.33,26.47-6.53,51.06-17.32,78.15-22.35,11.74-2.19,24-2.55,36-2.82,5.08-.12,10.68-.35,15.53.8",
  style: {
    fill: "none",
    stroke: "#edf1f0",
    strokeMiterlimit: 10,
    strokeWidth: 32
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "293.19 102.82 296.46 90.73 310.31 92.23 303.93 118.88",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M331.57,101.49a86.52,86.52,0,0,1,7.06,32.69H326.07L321,112.06",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M329,66.49l8.7.12L346.17,49h6.94l-7.22,23.6A6.31,6.31,0,0,1,340,77l-11.72.29",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M292.64,73.56,281.23,95.45l-16.47,11.06c-2.36.94-4.68,1.73-6.26,3.86s-2.13,5.61.22,7.41c4,3.07,8.4-3.41,10.51-6L285,104.49a15.31,15.31,0,0,0,6.66-6L300.88,83",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.75,87.41l-10-10.72,7.57-9.82a7.27,7.27,0,0,1,12.08.85h0a7.27,7.27,0,0,1-.7,8.2Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M297.75,87.41l-10-10.72,7.57-9.82a7.27,7.27,0,0,1,12.08.85h0a7.27,7.27,0,0,1-.7,8.2Z",
  style: {
    fill: "url(#linear-gradient-8)"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M335.13,65.34l-3.52,14.1-12.27-1A7.22,7.22,0,0,1,313.5,68h0a7.21,7.21,0,0,1,7.19-3.86Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M335.13,65.34l-3.52,14.1-12.27-1A7.22,7.22,0,0,1,313.5,68h0a7.21,7.21,0,0,1,7.19-3.86Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-9)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.87,66.52l11.58-1.38s.1,0,.1-.06l-.72-4.65,3-.44c2.36-.54,1.69-3.17,1.39-4.85l-.7-3.92c.5,0,1.12,0,1.3-.52a1.22,1.22,0,0,0-.14-.92,49.66,49.66,0,0,0-3-5.93A16,16,0,0,0,313.29,39c-1.49-1-3.1-.42-4.82.13A11.32,11.32,0,0,0,304,42a10.55,10.55,0,0,0-2.12,2.93,9.88,9.88,0,0,0,2.42,11.71Z",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 316.24,
  cy: 48.52,
  r: 0.55,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M315.4,51.78l2.94.66s-.52,1.43-1.65,1.26S315.4,51.78,315.4,51.78Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "315.83 60.43 311.46 60.95 316.28 63.31",
  style: {
    fill: "#ebb990",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.46,57.41a13.68,13.68,0,0,1-1.58-4.91c-.63-3.83-1.19-8.28,2.3-11a9.87,9.87,0,0,1,3.52-1.6c2.32-.57,3.82-.64,5.6-2.38,1.39-1.35,3.39-2.45,5.24-1.33a4.44,4.44,0,0,1,2,4.46c-.78,3.67-5.25,4.27-8.27,5l1.1,6.18c-1.11-.72-2.75-1.09-3.8-.3a2.84,2.84,0,0,0-1,1.93c-.22,1.85.82,2.69,1.85,4,.59.73,1,.41.5,1.53a2.9,2.9,0,0,1-2.19,1.35,5.48,5.48,0,0,1-4.94-2.45Z",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M295.79,88.46l2.58-19.79A5.37,5.37,0,0,1,303.7,64h14a5.37,5.37,0,0,1,5.11,3.71l6.79,20.74",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M295.79,88.46l2.58-19.79A5.37,5.37,0,0,1,303.7,64h14a5.37,5.37,0,0,1,5.11,3.71l6.79,20.74",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-10)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M390.27,137.82l-2.19-8-4.39-.49c-3.44-.66-2.59-4.51-2.24-7l.82-5.69c-.72,0-1.62,0-1.91-.69a1.79,1.79,0,0,1,.17-1.33,69.44,69.44,0,0,1,4-8.73,23,23,0,0,1,6.21-7.23c2.11-1.53,4.47-.76,7,0a16.48,16.48,0,0,1,6.66,4,15.28,15.28,0,0,1,3.2,4.13,14.27,14.27,0,0,1-2.94,17l4.78,11.49",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 386.81,
  cy: 111.05,
  r: 0.79,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M389.16,116.61l-4.22,1.1s.82,2,2.44,1.74S389.16,116.61,389.16,116.61Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "388.08 129.84 394.43 130.39 389.16 133.59",
  style: {
    fill: "#ebb990",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.68,148.74l-11.77,3.77-15.53-15.06L342.2,147.8l20.87,20.06a9.44,9.44,0,0,0,9.88,1.88",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M383.58,142l-21.36,23.66-23.66-1,1,15.32,22.54,1.81a12.27,12.27,0,0,0,9.61-3.52l9-8.9",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M274.09,135.38l-16.18,23.73.75-29.26-9.42-4.19-5.44,32.45a14.81,14.81,0,0,0,.23,6.49,15,15,0,0,0,8.86,9.84h0a15,15,0,0,0,17.39-4.63l15.44-19.7",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.73,140.82l20.06,12.39,13.13-15a11.71,11.71,0,0,0-5.13-18.82h0A11.71,11.71,0,0,0,281.06,123Z",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.73,140.82l20.06,12.39,13.13-15a11.71,11.71,0,0,0-5.13-18.82h0A11.71,11.71,0,0,0,281.06,123Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-11)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M301.08,124.56h20.27l2.55-12.88,5,.67c4,.21,4.08-4.25,4.36-7l.66-6.49c.78.25,1.79.42,2.28-.23a2,2,0,0,0,.19-1.52,79,79,0,0,0-2-10.69c-1.06-3.69-2.37-9-6.59-9.82-4.89-1-9.92.47-14.68,2-4.47,1.43-7,5.14-8,9.66a16.19,16.19,0,0,0-.13,6.43,50.72,50.72,0,0,0,2.37,5.87S301.08,124.56,301.08,124.56Z",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 329.21,
  cy: 92.25,
  r: 0.87,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.33,101.15a3.65,3.65,0,0,1-2.53-2.31l.77-.29a3,3,0,0,0,2.64,1.92v.82A3.28,3.28,0,0,1,330.33,101.15Z",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M319.85,90a4.71,4.71,0,0,1,4.33-3.47c2.06-.25,4.14.1,6.2-.07a12.32,12.32,0,0,0,4.12-1.08,6.89,6.89,0,0,0-.75-12.86,6.14,6.14,0,0,0-6.34,2,16.75,16.75,0,0,0-4.88-2.89,7.7,7.7,0,0,0-5.57.07,10.64,10.64,0,0,0-4.24,4.2c-1.64-.84-3.42-1.7-5.24-1.42a5.64,5.64,0,0,0-4,3.25,11.26,11.26,0,0,0-.9,5.24,5.75,5.75,0,0,0-6.25,7.62,9.19,9.19,0,0,0,3.83,4.33c-.38-.25-.85,2.57-.82,2.82a7.16,7.16,0,0,0,1.11,2.75,7.3,7.3,0,0,0,5.18,3.8,6.77,6.77,0,0,0,6.24-2.54,9.53,9.53,0,0,1-3.41-3.47,5.85,5.85,0,0,1-.17-4.08,5.53,5.53,0,0,1,1.59-2.56,4.31,4.31,0,0,1,6.83,1.71,1.94,1.94,0,0,0,.58,1,1.06,1.06,0,0,0,1.32-.28,3,3,0,0,0,.56-1.35A22.4,22.4,0,0,1,319.85,90Z",
  style: {
    fill: "#e8a51f"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, /*#__PURE__*/React.createElement("polyline", {
  points: "323.9 111.68 316.2 110.45 323.08 115.84",
  style: {
    fill: "#ebb990"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M285.67,331.67l-3.08,17.85a3.48,3.48,0,0,1-3.47,2.85H244.63c-6.75,0-8.45-9.13-2.11-11.38l.27-.1c9.06-3.06,24.34-9.31,24.34-9.31",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M351.75,331.67l3.07,17.85a3.49,3.49,0,0,0,3.47,2.85h34.5c6.74,0,8.44-9.13,2.11-11.38l-.27-.1c-9.06-3.06-24.35-9.31-24.35-9.31",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M363.22,140.82l-20.06,12.39-13.14-15a11.72,11.72,0,0,1,5.13-18.82h0A11.72,11.72,0,0,1,347.89,123Z",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M363.22,140.82l-20.06,12.39-13.14-15a11.72,11.72,0,0,1,5.13-18.82h0A11.72,11.72,0,0,1,347.89,123Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-12)"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "283.49 188.99 263.53 332.2 286.5 332.2 312.67 221.36 351.41 332.2 373.63 332.2 345.5 188.99",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "346.9 188.99 282.13 188.99 291.02 118.75 337.76 118.75 346.9 188.99",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "346.9 188.99 282.13 188.99 291.02 118.75 337.76 118.75 346.9 188.99",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-13)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.43,127.57c-.72-1.91.5-8.38.9-10.3a22.82,22.82,0,0,1,1.93-5.83c1.57-3,4.6-7.21,7.56-9,1.34-.82,2.5-.59,3.05,1,.71,2.07-.65,4.27-1.33,6.16a8.3,8.3,0,0,0-.51,5.05c.38,1.4,1.19,2.63,1.53,4a14.17,14.17,0,0,1,.1,5.39c-.4,2.24-2.79,4.11-4,5.76",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.42,136.89A15.56,15.56,0,0,0,381.07,146s-8.18,15-6,20.19A6.1,6.1,0,0,0,379.8,170l-.9,26.19,46.41,1.07-1.95-49A13.67,13.67,0,0,0,407.12,134Z",
  style: {
    fill: "#f4b01a"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.42,136.89A15.56,15.56,0,0,0,381.07,146s-8.18,15-6,20.19A6.1,6.1,0,0,0,379.8,170l-.9,26.19,46.41,1.07-1.95-49A13.67,13.67,0,0,0,407.12,134Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-14)"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "404.21 278.17 413.39 346.83 426.88 346.83 426.1 280.64",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M412.94,343.46c-4.12,7.07-16.17,3.07-16.61,12.14h27.78a3.24,3.24,0,0,0,3.24-3.32l-.19-8.21",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M380.57,343.1c-4.12,7.06-16.17,3.07-16.62,12.13h27.78a3.23,3.23,0,0,0,3.24-3.31l-.19-8.22",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "398.21 279.58 394.5 342.86 379.47 343.56 381.27 271.47",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M423.25,188.49l-44-.47-22.36,82.33a10.3,10.3,0,0,0,9.92,13l62.17.16A12.67,12.67,0,0,0,441.36,268Z",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.25,166.59,416,188a6.2,6.2,0,0,1,.55,3.06l-2.2,31.33c-.62,3.61-1.74,7.05-1.64,10.82.09,3.34.45,8.62,4.14,9.91,7.32,2.56,8.4-8.1,8.34-13.07,0-2.09-1.29-5.19-1-6.81l7-28.34a16,16,0,0,0,0-7.5l-5.47-23",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M428.29,167.19l-24.43,1.92-5-20.14a12.18,12.18,0,0,1,13.69-15h0a12.18,12.18,0,0,1,10,9.44Z",
  style: {
    fill: "#f4b01a"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M428.29,167.19l-24.43,1.92-5-20.14a12.18,12.18,0,0,1,13.69-15h0a12.18,12.18,0,0,1,10,9.44Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-15)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M428.46,148.23c2.73,4.21,4.63,9,10.21,10.46,2.92.76,5.86.26,8.71-.45,3.93-1,6.21-2.78,8.91-5.74,4.59-5,4.55-13.55-1-17.93-2.4-1.88-5.58-2.39-8.35-3.5-3.23-1.29-5-3.66-7.07-6.26-2.68-3.29-5.16-5.67-9.19-7.21-2.89-1.11-6-1.11-8.92-2.15-6.06-2.2-8.4-7.37-12.55-11.75-3.23-3.4-7.24-5.11-11.62-6.48-2.29-.72-5.69-1.77-8-.66-3.7,1.79-.15,6.22,2.15,7.59a22.38,22.38,0,0,0,6.76,2.27l-1.28,9c1.56-1.09,3.91-1.7,5.47-.61a4.05,4.05,0,0,1,1.53,2.74c.54,3.47-2,5.47-4.53,7.13.73,1.87,1.84,4.3,3.54,5.52,1.54,1.1,3.34.92,4.7,2.38,1.55,1.67,1.66,4.26,3.1,6.08a10.17,10.17,0,0,0,5.51,3.19c3.75,1.07,7.7.92,10.43,4.27A23.49,23.49,0,0,1,428.46,148.23Z",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M344,273.14l-6.92,13.72c-2.43,4.83-5.54,9.78-7,14.94a6,6,0,0,0-.39,3.15c.44,1.7,2,5.1,4.34,4.2s3.22-4,4.37-5.91a8.64,8.64,0,0,0,1.35,2.28c1.58,1.36,1.79-.74,1.69-1.81a18.87,18.87,0,0,0-.92-3.93l11.16-17.57",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M390,261.85l15.18.35,5.64-15,7.59,1.06L411,270.92a4.47,4.47,0,0,1-4.29,3.08l-18.62-.15",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M391.71,260l-2.26,15.23-13,.22A7.65,7.65,0,0,1,369.18,265h0a7.63,7.63,0,0,1,7.19-4.81Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M391.71,260l-2.26,15.23-13,.22A7.65,7.65,0,0,1,369.18,265h0a7.63,7.63,0,0,1,7.19-4.81Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-16)"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "353.5 318.04 347.23 344.9 361.56 344.9 368.19 319.65",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M347.24,342.78a8.36,8.36,0,0,1-4.1,4.49c-1.8,1-3.8,1.66-5.67,2.56a7.19,7.19,0,0,0-2.24,1.51,3.1,3.1,0,0,0-.89,2.48,2,2,0,0,0,1.8,1.74h23.29l2.84-12.09",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "388.24 318.12 394.51 344.99 380.18 344.99 373.56 319.73",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M385.82,285.8l11.27,30.37a4.13,4.13,0,0,1-3.75,5.63H348.51a4.11,4.11,0,0,1-4-4.84l7.8-30.27",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M360.46,262.07l12.66-.66s.12-.05.12-.07l-.45-5.09,3.32-.26c2.59-.41,2.05-3.32,1.85-5.16l-.48-4.3c.55.05,1.23,0,1.45-.47a1.33,1.33,0,0,0-.09-1,51,51,0,0,0-2.78-6.65,17.44,17.44,0,0,0-4.49-5.59c-1.55-1.2-3.34-.68-5.24-.2a12.23,12.23,0,0,0-5.09,2.81,11.59,11.59,0,0,0-2.52,3,10.74,10.74,0,0,0,1.79,12.88Z",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 374.09,
  cy: 243.36,
  r: 0.6,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M375.77,248.54a2.2,2.2,0,0,1-2.17-1.1",
  style: {
    fill: "none",
    stroke: "#8b5624",
    strokeMiterlimit: 10,
    strokeWidth: "0.25px"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "372.79 256.25 368.01 256.5 373.07 259.41",
  style: {
    fill: "#ebb990",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M355.25,251.8a14.89,14.89,0,0,1-1.37-5.44c-.3-3.09-.75-7,1.25-9.67a10.1,10.1,0,0,1,4.19-2.8l3.41-1.52a14.31,14.31,0,0,1,5.79-1.66c4.78,0,6.74,5,2.27,7.51a16.82,16.82,0,0,1-5.14,1.55l.75,6.77c-1.15-.85-2.9-1.37-4.1-.59a3,3,0,0,0-1.22,2c-.37,2,.7,3,1.72,4.42.59.84,1,.51.43,1.69a3.18,3.18,0,0,1-2.47,1.31,5.94,5.94,0,0,1-5.18-3A6.48,6.48,0,0,1,355.25,251.8Z",
  style: {
    fill: "#e8a51f"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 370.79,
  cy: 226.02,
  r: 4.92,
  style: {
    fill: "#e8a51f"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 350.21,
  cy: 234.26,
  r: 5.99,
  style: {
    fill: "#e8a51f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M350.34,289l3.06-23.48a6.39,6.39,0,0,1,6.33-5.56h16.64a6.4,6.4,0,0,1,6.07,4.4L390.49,289",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M350.34,289l3.06-23.48a6.39,6.39,0,0,1,6.33-5.56h16.64a6.4,6.4,0,0,1,6.07,4.4L390.49,289",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-17)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M394.5,342.86a8.38,8.38,0,0,0,4.1,4.5c1.81,1,3.8,1.65,5.67,2.55a7.37,7.37,0,0,1,2.24,1.51,3.1,3.1,0,0,1,.89,2.48,2,2,0,0,1-1.8,1.74H382.31l-2.84-12.08",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.46,284.2l-10.31-11.09L350,263a7.51,7.51,0,0,1,12.49.88h0a7.51,7.51,0,0,1-.71,8.48Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M352.46,284.2l-10.31-11.09L350,263a7.51,7.51,0,0,1,12.49.88h0a7.51,7.51,0,0,1-.71,8.48Z",
  style: {
    fill: "url(#linear-gradient-18)"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M410.83,249.46c-2.13-1.94.05-13.22,3.29-14.12s2.56,3.52,2.83,5.64,1.59,3.49,2.12,5.42c.62,2.23-.7,4.82-2.59,6.12",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.86,51.07l-.78-5.8c-.11-.78-1.41-6.33.52-4.91.94.69.9,2.55,1.53,3.46,1.59-2.32,4.86-9.13,8.09-4.56,1.31,1.86.45,4.46-.52,6.31l-2.49,5.9",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M293.33,102.25s-5.54,12.22-7.06,32.69h12.56l5.1-22.13",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M334,113.15s4.51,2.95,4.66,21H326.07l-3.59-15.59",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M286.75,134.42a16.45,16.45,0,0,1-4.94,4.08c-1.78,1.13-3.36,2.61-2,4.65h15.33a1.57,1.57,0,0,0,1.51-1.14l2.13-7.59",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M337.93,133.45a16.48,16.48,0,0,0,4.94,4.09c1.78,1.13,3.36,2.61,2,4.65h-15a2,2,0,0,1-2-1.49l-2-7.25",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.61,192.89c1.36-.53,2.11-1.65,3.26-2.51s3-1.1,3.85-2.24.74-3,1.32-4.32,2-2.43,2.25-3.91-.82-2.92-1-4.42.54-3.19,0-4.53-2.16-2.16-3-3.33-1.07-3-2.18-3.94-2.91-.76-4.23-1.36-2.37-2.07-3.81-2.3-2.86.83-4.32,1-3.12-.55-4.43,0-2.11,2.21-3.26,3.07c-1.32,1-2.79,1.17-3.84,2.49a4.21,4.21,0,0,0-.85,4.47c-1.38,1.27-2.25,3.34-1.3,4.93a4.08,4.08,0,0,1,.49.89,3.27,3.27,0,0,1,0,1.28,3.71,3.71,0,0,0,1,2.89,8.79,8.79,0,0,1,1,1,6.58,6.58,0,0,1,.46.92,4.84,4.84,0,0,0,3.5,2.53c1,.15,1.72-.08,2.69,0a5.17,5.17,0,0,1,3.79,1.92c1.16,1.56,1.2,4.65,2.87,5.72C665.21,194,668.22,193.44,669.61,192.89Z",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M704.44,284.47c.25-.21,1.32.45,2.38.2h0a2,2,0,0,0,1.48-2.38l-6.81-29.09-3.86,2.18",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M558,254.48l3.85-.38L555,283.19a2,2,0,0,1-2.38,1.48h0c-1.07-.25-1.73-1.32-1.48-1.1",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M557.11,246.46l-10.92-33.64a8.2,8.2,0,0,1,7.8-10.73H711.15a8.19,8.19,0,0,1,8,10l-7.76,34.36",
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M557.11,246.46l-10.92-33.64a8.2,8.2,0,0,1,7.8-10.73H711.15a8.19,8.19,0,0,1,8,10l-7.76,34.36",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-19)"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 539.08,
  y: 244.46,
  width: 185.12,
  height: 10.86,
  rx: 3.08,
  ry: 3.08,
  style: {
    fill: "#ee8322"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M635.91,214.84l-7.4,13.4a5.32,5.32,0,0,1-9.11,1.07l-7.23-16.78-1.32-8.67,10.21,4.34,2.9,12,6.5-9.81",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "676.1 249.89 679.84 285.93 670.17 285.93 663.32 253.41",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M685.14,209.51l4.18,30.86,7.28,3.74c1.61,1.25-.75,1.89-2,2.21H677.86l-5.05-35.63",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.64,210.62l-4.18,30.85-7.28,3.75c-1.61,1.24.75,1.88,2,2.2h16.75L656,211.79",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "650.41 251.14 646.67 287.18 656.35 287.18 663.19 254.66",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.35,197.57l-1.42-5.19-2.86-.32c-2.23-.43-1.68-2.93-1.45-4.51l.53-3.71c-.47,0-1.06,0-1.24-.45a1.17,1.17,0,0,1,.11-.87,44.7,44.7,0,0,1,2.6-5.67,14.86,14.86,0,0,1,4-4.7c1.37-1,2.9-.5,4.53,0a10.72,10.72,0,0,1,4.33,2.58,9.82,9.82,0,0,1,2.08,2.68,9.29,9.29,0,0,1-1.91,11.09l3.11,7.47",
  style: {
    fill: "#c1813e"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 654.11,
  cy: 180.15,
  r: 0.52,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M655.63,183.77l-2.74.71s.53,1.33,1.58,1.13S655.63,183.77,655.63,183.77Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "654.93 192.38 659.06 192.73 655.63 194.81",
  style: {
    fill: "#ebb990",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.12,192.06a8.31,8.31,0,0,0,2.06-3.7,20.08,20.08,0,0,0-.56-10c-1.26-4-5.77-6-9.53-7.2-1.49-.47-3.7-1.16-5.21-.43-2.4,1.16-.09,4,1.4,4.93a14.47,14.47,0,0,0,4.4,1.48l-.83,5.84c1-.7,2.54-1.1,3.56-.39a2.66,2.66,0,0,1,1,1.78c.34,2.26-1.29,3.56-2.95,4.64.78,2,1.88,4.76,4.51,4.27A4.12,4.12,0,0,0,669.12,192.06Z",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M687.06,212.16l-9.92.22,2.43,22.48-30-.44L652,213.26H641s.75-16.29,21.18-17.58C685,194.23,687.06,212.16,687.06,212.16Z",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M687.06,212.16l-9.92.22,2.43,22.48-30-.44L652,213.26H641s.75-16.29,21.18-17.58C685,194.23,687.06,212.16,687.06,212.16Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-20)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M681.8,264a3.62,3.62,0,0,0,3.59-4.12l-4.49-28.38c-.87-5.54-5.74-8.24-11.34-8l-10.17.34a11.08,11.08,0,0,0-10.52,9c-1.94,10.1-5,21-6.25,27.92a2.82,2.82,0,0,0,2.78,3.3Z",
  style: {
    fill: "#f4b01a"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M681.8,264a3.62,3.62,0,0,0,3.59-4.12l-4.49-28.38c-.87-5.54-5.74-8.24-11.34-8l-10.17.34a11.08,11.08,0,0,0-10.52,9c-1.94,10.1-5,21-6.25,27.92a2.82,2.82,0,0,0,2.78,3.3Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-21)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M575.89,209.51l-4.19,30.86-7.27,3.74c-1.61,1.25.74,1.89,2,2.21h9.89a4,4,0,0,0,3.93-3.42l4.56-32.21",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.57,198.73l1.58-5.33,3-.26c2.31-.4,1.8-3,1.6-4.63l-.47-3.84c.48,0,1.08,0,1.28-.43a1.19,1.19,0,0,0-.09-.9,46.23,46.23,0,0,0-2.56-5.91,15.42,15.42,0,0,0-4.06-4.94c-1.4-1.06-3-.57-4.68-.12a11,11,0,0,0-4.52,2.56,10,10,0,0,0-2.21,2.73,9.57,9.57,0,0,0,1.73,11.47l-3.36,7.65",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 607.26,
  cy: 180.81,
  r: 0.53,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "606.15 193.4 601.89 193.68 605.38 195.9",
  style: {
    fill: "#ebb990",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M609.05,185.78a2.15,2.15,0,0,1-2.23-.75",
  style: {
    fill: "none",
    stroke: "#8b5624",
    strokeMiterlimit: 10,
    strokeWidth: "0.25px"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M590.16,189.88c-.3-.4-1.29-1.92-.33-2.13-1.64-.26-3.27-2.61-3.29-4.25a6.1,6.1,0,0,1,4.79-5.88,5.55,5.55,0,0,1,3.71-6.07,12.38,12.38,0,0,1,5.22-.3c.43.05,1.08.52,1.47.45s1.28-1,1.94-1.15c2.07-.58,4.87.53,4.83,3,0,3.47-5.08,3.59-7.4,3.53l-.65,6.05c-.84-1-2.26-1.76-3.46-1.3a2.76,2.76,0,0,0-1.45,1.53c-.92,2.17.38,3.88,1.77,5.39,1.08,1.16-3.27,2.5-4,2.49C591.85,191.19,591,191,590.16,189.88Z",
  style: {
    fill: "#050505"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M574,212.76l12.42,1.43L589.3,204a6.21,6.21,0,0,0-6.7-7.88h0a6.23,6.23,0,0,0-5.29,4.63Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M574,212.76l12.42,1.43L589.3,204a6.21,6.21,0,0,0-6.7-7.88h0a6.23,6.23,0,0,0-5.29,4.63Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-22)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M623.34,208l-10.64,6.57-7-8a6.22,6.22,0,0,1,2.72-10h0a6.2,6.2,0,0,1,6.75,1.94Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M623.34,208l-10.64,6.57-7-8a6.22,6.22,0,0,1,2.72-10h0a6.2,6.2,0,0,1,6.75,1.94Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-23)"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "614.68 233.49 580.36 233.49 585.07 196.26 609.85 196.26 614.68 233.49",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "614.68 233.49 580.36 233.49 585.07 196.26 609.85 196.26 614.68 233.49",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-24)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M580.41,246.32h34.21a2.41,2.41,0,0,0,2.65-2.64c-.28-1.44-.8-3.81-1.7-7.78-1.1-4.82-6-8.37-11.81-8.53L592.37,227c-6.29-.18-11.75,3.63-12.72,8.88l-1.37,8.33A2,2,0,0,0,580.41,246.32Z",
  style: {
    fill: "#006c43"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M582,239.54l-2.37,40.89,10.13-.74,6.29-38.41a7.08,7.08,0,0,0-7-8.21h0A7.08,7.08,0,0,0,582,239.54Z",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M580.85,278.29a1.58,1.58,0,0,0-1.57.92c-.91,2.1-2.82,4.1-4.28,5.71-.85.95-3.19,4.48-.51,4.74l14.94-.07,1.11-9.14a1.25,1.25,0,0,0-1.13-1.48Z",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M648.81,278.25a1.55,1.55,0,0,0-1.57.92c-.91,2.1-2.82,4.09-4.28,5.7-.85.95-3.19,4.49-.5,4.74l14.93-.06,1.11-9.15a1.25,1.25,0,0,0-1.13-1.48Z",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M612.78,239.54l2.56,40.89-9.84.58-6.76-39.73a7.08,7.08,0,0,1,7-8.21h0A7.07,7.07,0,0,1,612.78,239.54Z",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.54,280.19l.91,9.47,15.16-.07c2.69-.25.35-3.79-.5-4.74-1.51-1.66-3.51-3.74-4.37-5.92a1.1,1.1,0,0,0-1.1-.73l-9.14.72A1.07,1.07,0,0,0,604.54,280.19Z",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M668.82,280.19l.91,9.47,15.17-.07c2.68-.25.35-3.79-.51-4.74-1.51-1.66-3.51-3.74-4.37-5.92a1.1,1.1,0,0,0-1.1-.73l-9.14.72A1.07,1.07,0,0,0,668.82,280.19Z",
  style: {
    fill: "#e65e9b"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 608.97,
  y1: 218.11,
  x2: 609.41,
  y2: 218.7,
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.31,211.5l.05-3.06c0-.88-.74-4.75.69-4.65,1.15.09,1,2.34,1.58,3l1.57-2.56c.47-.77,1.23-2.81,2.22-3,1.76-.44,2.79,3.15,3.14,4.35.61,2.11-.88,4.1-1.75,6-.39.84-2,3.32-2.36,4.18",
  style: {
    fill: "#ebb990"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 662.14,
  cy: 188.71,
  r: 0.72,
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 107.21,
  y: 290.28,
  width: 13.36,
  height: 4.14,
  rx: 0.83,
  ry: 0.83,
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.51,279.47l-1.05,6.82a2.54,2.54,0,0,0,1.87,2.84l12.81,3.35c3.21.84,5.19-3.1,2.25-4.55l-.08,0c-1-.45-2-.72-2.94-1.24-2.15-1.24-3-3.62-3.63-5.78",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "87.4 219.24 100.53 239.94 105.08 282.36 116.7 283.12 112.85 225.82",
  style: {
    fill: "#acacac"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 94.69,
  y: 222.24,
  width: 2.5,
  height: 15.11,
  transform: "translate(-112.14 93.01) rotate(-34.02)",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 78.29,
  y: 235.48,
  width: 62.43,
  height: 2.5,
  transform: "translate(-1.85 0.86) rotate(-0.45)",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 75.59,
  y: 218.21,
  width: 25.04,
  height: 7.98,
  rx: 1.59,
  ry: 1.59,
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 77.33,
  cy: 268,
  r: 28.5,
  style: {
    fill: "none",
    stroke: "#0e1010",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166.84,
  cy: 267.04,
  r: 28.5,
  style: {
    fill: "none",
    stroke: "#0e1010",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 66.99,
  y: 233.27,
  width: 2.5,
  height: 35.31,
  transform: "translate(-96.39 49.64) rotate(-24.07)",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.9,236.05H58.42a3,3,0,1,1,0-6H80.9a3,3,0,1,1,0,6Zm-22.48-3.47a.5.5,0,0,0-.48.49.49.49,0,0,0,.48.48H80.9a.49.49,0,0,0,.48-.48.5.5,0,0,0-.48-.49Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.38,267.41l-20.89-61.77A5.93,5.93,0,0,0,137.7,202l-8.26,4.36-1.16-2.22,8.37-4.41a8.42,8.42,0,0,1,6.77.14,8.32,8.32,0,0,1,4.44,5l20.89,61.77Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 125.32,
  y: 203.25,
  width: 9,
  height: 3.69,
  rx: 0.52,
  ry: 0.52,
  transform: "translate(-85.15 92.39) rotate(-30)",
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 99.69,
  y: 246.68,
  width: 65.83,
  height: 2.5,
  transform: "translate(-146.75 216.05) rotate(-55.35)",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 111.8,
  y: 275,
  width: 13.36,
  height: 4.14,
  rx: 0.83,
  ry: 0.83,
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166.84,
  cy: 267.04,
  r: 2.92,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.54,270.53H78.32a3,3,0,0,1-3-3v-3.21a3,3,0,0,1,3-3h32.22a3,3,0,0,1,3,3v3.21A3,3,0,0,1,110.54,270.53Zm-32.22-8.14a1.9,1.9,0,0,0-1.9,1.9v3.21a1.9,1.9,0,0,0,1.9,1.9h32.22a1.9,1.9,0,0,0,1.89-1.9v-3.21a1.9,1.9,0,0,0-1.89-1.9Z",
  style: {
    fill: "#ac41d8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.18,265.55v6.91a2.54,2.54,0,0,0,2.27,2.52l13.18,1.36c3.3.34,4.65-3.85,1.53-4.84l-.08,0c-1-.31-2.12-.4-3.1-.79-2.31-.9-3.48-3.12-4.46-5.16",
  style: {
    fill: "#727d79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.19,199.34c-2.08,7.28-1,14.25,4.77,19.11a25.9,25.9,0,0,0,4.22,2.71q8.08,4.46,16.56,8.11L109.8,268l11.14,0-1.67-38c-.79-6.14,0-6.77-2.67-9.78L98.87,199.4",
  style: {
    fill: "#d7d8d6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.41,172.09l11,2s.08,0,.09,0l.53-3.62,2.36.37c1.87.14,2-2,2.14-3.29l.39-3.08c.36.13.84.22,1.08-.08a1,1,0,0,0,.11-.72,36.65,36.65,0,0,0-.84-5.1,12.38,12.38,0,0,0-2.2-4.63c-.88-1.1-2.21-1-3.61-1a8.76,8.76,0,0,0-4,1.11,8,8,0,0,0-2.25,1.69,9.33,9.33,0,0,0-2.06,6.1",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.1,165.53a2.19,2.19,0,0,1-1.51-1.38l.46-.17a1.77,1.77,0,0,0,1.57,1.14v.49A2.05,2.05,0,0,1,103.1,165.53Z",
  style: {
    fill: "#8b5624",
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.39,156.35a19.71,19.71,0,0,0-2.54.7c-1.1.62-1.34,1.62-1.66,2.73-.27.94-.2,2.61-1.4,2.89-2,.46-1-4.26-4.24-3.45a2.93,2.93,0,0,0-2,2.76,5.57,5.57,0,0,0,1.23,3.35c-1,1.84-2.38,4-4.46,3.85a5,5,0,0,1-1.47-.38,21.57,21.57,0,0,1-4.64-2.48c-1.65-1.16-3.24-2.6-5.23-3a10.61,10.61,0,0,0-3.92.22,36.25,36.25,0,0,1-7,.88,11.23,11.23,0,0,1-6.68-2c-1.68-1.28-2.83-3.17-4.58-4.35-2.46-1.65-5.84-1.72-8-3.77-2.52-2.4-2.21-6.72-.26-9.61,2.79-4.16,8.77-6,13.22-3.68a32.94,32.94,0,0,1,5.09,3.93c1.67,1.34,3.7,2.49,5.84,2.31,1.6-.14,3-1,4.54-1.55a12.62,12.62,0,0,1,11.55,1.57,38.26,38.26,0,0,0,3.84,2.9c2.16,1.17,3.77,1,6.13,1a17.08,17.08,0,0,1,3.88.69c1.24.28,3.31,1,3.91,2.25C105.23,155.47,104.45,156,103.39,156.35Z",
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.21,177.38l-3.66,23.77,26.56,4.4.34-21.1c0-7.58-3.31-10.65-7.19-13.23-5.67-3.76-14.21-1.43-15.85,5.17C81.33,176.71,81.26,177,81.21,177.38Z",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.9,187.6,99,198.66a7.68,7.68,0,0,0,5.92,3.26l11.17.42,8.58.32a42.83,42.83,0,0,1,6,.17c1.64.3,2.42,1.9,3.79,2.77,1.1.69,2.8,1.4,3.91.33,2.44-2.36-2.62-6-4.29-7.15-2.26-1.62-5.41-1.77-8.09-2.3L118.24,195l-12.92-2.54-.16,0-5.33-9.08",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "_Path_",
  "data-name": "<Path>",
  d: "M95.76,172.82l7,12.41L89.86,191.1,83.5,178.81a6.84,6.84,0,0,1,3.71-9h0A6.83,6.83,0,0,1,95.76,172.82Z",
  style: {
    fill: "#00d38d"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "_Path_2",
  "data-name": "<Path>",
  d: "M95.76,172.82l7,12.41L89.86,191.1,83.5,178.81a6.84,6.84,0,0,1,3.71-9h0A6.83,6.83,0,0,1,95.76,172.82Z",
  style: {
    mixBlendMode: "multiply",
    fill: "url(#linear-gradient-25)"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102.63,
  cy: 160.85,
  r: 0.34,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75.85,
  cy: 268.92,
  r: 2.92,
  style: {
    fill: "#0e1010"
  }
}), /*#__PURE__*/React.createElement("polyline", {
  points: "100.09 170.5 97.57 170 99.84 172.01",
  style: {
    fill: "#8b5624"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.03,
  y: -76.2,
  width: 841.83,
  height: 450.53,
  style: {
    fill: "none"
  }
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuildingMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/building-mobile.7e8c36ea8fde70207d2f1279c1dff606.svg";